// src/api.js
import axios from 'axios';

const api = axios.create({
    baseURL: 'https://demo.foodwatch.me/api', // Base URL
});

export default api;
